import { createFileRoute } from "@tanstack/react-router";
import { WarehouseIcon } from "../../components/icons/sidebar-icons";
import { ModulePlaceholder } from "../../components/modules/module-placeholder";

export const Route = createFileRoute("/_app/wsl-inventory")({
	component: () => <ModulePlaceholder messageKey="wslInventory.message" icon={WarehouseIcon} />,
});
